import MilestonesSerializer from './base';

export default class Expectation extends MilestonesSerializer {}
